import { defineMessages } from 'react-intl';

export default defineMessages({
    wantToChangeLine: {
        id: 'fnol.cpp.views.select-line.wantToChangeLine',
        defaultMessage: 'Change Line of Business?'
    },
    claimDataEnteredCleared: {
        id: 'fnol.cpp.views.select-line.claimDataEnteredCleared',
        defaultMessage: 'We will not save the information you have entered, do you want to continue?'
    },
    cpLine: {
        id: 'fnol.cpp.views.select-line.Commercial Property',
        defaultMessage: 'Commercial Property'
    },
    crLine: {
        id: 'fnol.cpp.views.select-line.Crime',
        defaultMessage: 'Crime'
    },
    glLine: {
        id: 'fnol.cpp.views.select-line.General Liability',
        defaultMessage: 'General Liability'
    },
    imLine: {
        id: 'fnol.cpp.views.select-line.Inland Marine',
        defaultMessage: 'Inland Marine'
    },
});
